import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApplyCoupon } from "../../hooks/useApplyCoupon";
import { useAppDispatch } from "../../../../../common/hooks/hooks";
import { closeGlobalModal } from "../../../../../common/features/globalModal/globalModalSlice";

interface CartApplyCouponFormProps {
  isModalContext?: boolean;
}

const CartApplyCouponForm: React.FC<CartApplyCouponFormProps> = ({
  isModalContext = false,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [couponCode, setCouponCode] = useState("");

  const { handleApplyCoupon, isApplying } = useApplyCoupon();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!couponCode.trim() || isApplying) return;

    const result = await handleApplyCoupon({ code: couponCode });

    if (result.success) {
      setCouponCode("");
      if (isModalContext) {
        dispatch(closeGlobalModal());
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
  };

  return (
    <form className="cart-apply-coupon-form" onSubmit={handleSubmit}>
      <div className="cart-apply-coupon-form__input-group">
        <input
          type="text"
          value={couponCode}
          onChange={handleInputChange}
          placeholder={t("cartApplyCouponForm.placeholder", "Coupon code")}
          disabled={isApplying}
          autoFocus={isModalContext} // Autofocus when in a modal
        />
        <button type="submit" disabled={isApplying}>
          {isApplying
            ? t("cartApplyCouponForm.applyingButton", "Applying...")
            : t("cartApplyCouponForm.applyButton", "Apply Coupon")}
        </button>
      </div>
    </form>
  );
};

export default CartApplyCouponForm;
